import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-saving-indicator',
  templateUrl: './saving-indicator.component.html',
  styleUrls: ['./saving-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SavingIndicatorComponent {}
